exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-control-lg .custom-control-label::before,\n.custom-control-lg .custom-control-label::after {\n    top: 0.1rem !important;\n    left: -2rem !important;\n    width: 1.25rem !important;\n    height: 1.25rem !important;\n}\n.custom-control-lg .custom-control-label {\n    margin-left: 0.5rem !important;\n    font-size: 15px !important;\n}\n.fixed-top-selling {\n    position: fixed;\n    float: right !important;\n    /* top: 0; */\n    /* right: 0; */\n    /* left: 0; */\n    width: 37%;\n}\n.fixed-top-downpayment {\n    position: fixed;\n    float: right !important;\n    top: 48%;\n    /* right: 0; */\n    /* left: 0; */\n    width: 37%;\n}\n.mt-4-5 {\n    margin-top: 2rem !important;\n}\n.bubble-info {\n    position: fixed;\n    right: 25px;\n    bottom: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-549044e9","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Dashboard/Pages/Pos/Form.vue
// module id = LAPA
// module chunks = 4